export const JonathonBurgess = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="jonathanBurgessModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/jonathanburgess.jpg"
                    alt="Jonathan Burgess"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Jonathan Burgess
                    </h4>
                    <p style={{ lineHeight: "26px" }}>
                      PLA | LEED AP ND & BD+C
                    </p>
                    <p style={{ lineHeight: "13px" }}>
                      Vice-President of Sustainable Operations, The Spinnaker
                      Group
                    </p>
                    <p style={{ paddingTop: "17px" }}>
                      <strong>
                        "You see a blind man is walking towards a well, if he
                        falls in, who's at fault?"
                      </strong>
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      Jonathan Burgess is Vice President of Sustainable
                      Operations for The Spinnaker Group, a premier
                      green-building consulting firm based in South Florida. His
                      firm has helped inform the design of over 100 Leadership
                      in Energy and Environmental Design (LEED) certified
                      building projects, and has provided Commissioning Services
                      on more than half a billion square feet of buildings
                      worldwide.
                    </p>

                    <p>
                      In addition to his practitioner role, Jonathan also serves
                      as an advisor and sustainability educator, most notably as
                      a visiting Professor at the University of Miami’s School
                      of Architecture.
                    </p>
                    <p>
                      Jonathan is also a licensed Landscape Architect whose
                      professional experience includes site design, land
                      planning and project management for major public and
                      private developments covering practically all land use
                      types. And has recently achieved a WELL Acredited
                      Professional credential enhancing his ability to support
                      the goals of human sustainability he shares with BBF.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
